/// <reference types="vite/client" />
import { createApp } from 'vue';
import { createPinia, setActivePinia } from 'pinia';
import App from './App.vue';
import router from './router';
import Toast, { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { initToast } from './services/api/interceptors';

import './styles/tailwind.css';
import './styles/themes.scss';
import './styles/main.scss';

// PrimeVue imports
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';
import { primevueConfig } from './config/primevue';
import Aura from '@primeuix/themes/aura';
import 'primeicons/primeicons.css';
import './styles/primevue-overrides.scss';

try {
  const app = createApp(App);

  const pinia = createPinia();
  app.use(pinia);
  // Allows using stores outside component setup (e.g. during app bootstrap)
  setActivePinia(pinia);
  
  // Initialize auth store to restore user from localStorage
  import('@/modules/admin/stores/auth').then(({ useAuthStore }) => {
    useAuthStore(pinia);
  });


  app.use(router);

  // PrimeVue setup
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        // Keep PrimeVue's light/dark in lockstep with the app theme: useTheme
        // toggles `.p-dark` on <html> alongside data-theme. The default
        // ('system') follows the OS instead, which let PrimeVue render light
        // surfaces inside a dark app theme (Trello #158).
        darkModeSelector: '.p-dark',
        // cssLayer: false,
      },
    },
    ...primevueConfig,
  });
  // PrimeVue ConfirmationService for useConfirm
  app.use(ConfirmationService);
  // PrimeVue directive used as v-tooltip in templates
  app.directive('tooltip', Tooltip);
  
  app.use(Toast, {
    transition: 'Vue-Toastification__bounce',
    maxToasts: 20,
    newestOnTop: true,
    position: 'bottom-right',
  });

  // Initialize toast for interceptors - useToast() must be called after app is created
  // The interceptors will use useToast() internally when needed
  try {
    initToast(useToast());
  } catch (error) {
    console.warn('Failed to initialize toast:', error);
  }

  const appElement = document.getElementById('app');
  if (!appElement) {
    throw new Error('App element not found');
  }

  app.mount('#app');
  console.log('Vue app mounted successfully');
} catch (error) {
  console.error('Failed to mount Vue app:', error);
  // Show error message in the DOM
  const appElement = document.getElementById('app');
  if (appElement) {
    appElement.innerHTML = `
      <div style="padding: 20px; font-family: sans-serif; background: white; min-height: 100vh;">
        <h1 style="color: red;">Application Error</h1>
        <p>Failed to start the application. Please check the console for details.</p>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; overflow: auto; white-space: pre-wrap;">${error instanceof Error ? error.message : String(error)}</pre>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; overflow: auto; white-space: pre-wrap; margin-top: 10px;">${error instanceof Error ? error.stack : ''}</pre>
      </div>
    `;
  }
}

